import PropTypes from "prop-types";
import MDBox from "theme/components/MDBox";
import MDInput from "theme/components/MDInput";

function FirstNameField({ displayName, fieldRef, isOptional, options }) {
  // console.log(options);
  return (
    <MDBox>
      <MDInput
        name={fieldRef}
        id={`dff_${fieldRef}`}
        margin="dense"
        label={displayName}
        type="text"
        fullWidth
        variant="outlined"
        // onBlur={(e) => {
        //   if (e.target.value === "") {
        //     return;
        //   }
        // }}
        options={options}
      />
    </MDBox>
  );
}

// Typechecking props of the Transaction
FirstNameField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

FirstNameField.defaultProps = {
  options: null,
};

export default FirstNameField;
